import { useState } from 'react';
import classNames from 'classnames';

import { ForecastDaySummary } from 'hooks/useGetForecast';
import ForecastDailyLoader from './ForecastDailyLoader';
import ForecastDay from './ForecastDay';
import DayOfTheWeek from 'components/common/dates/DayOfTheWeek';
import Button, { ButtonVariant } from 'components/common/buttons/Button';

type ForecastDailyProps = {
  className?: string;
  dailyForecasts?: ForecastDaySummary[];
  isLoading: boolean;
};

function ForecastDaily({ className, dailyForecasts, isLoading }: ForecastDailyProps) {
  const [dayNumber, setDayNumber] = useState(0);

  if (isLoading) {
    return <ForecastDailyLoader />;
  }

  if (dailyForecasts) {
    return (
      <div data-testid="forecast-daily" className={className}>
        {/* Daily Forecast Button Bar */}
        <div className="mb-2 flex items-center justify-around rounded bg-gradient-to-r from-slate-200/50 to-slate-50 dark:from-slate-800 dark:to-slate-900">
          <div>
            <Button
              variant={ButtonVariant.Text}
              className={classNames(
                { 'underline underline-offset-4': dayNumber === 0 },
                'text-sm uppercase',
              )}
              onClick={() => setDayNumber(0)}
            >
              Today
            </Button>
          </div>
          <div>
            <Button
              variant={ButtonVariant.Text}
              className={classNames(
                { 'underline underline-offset-4': dayNumber === 1 },
                'text-sm uppercase',
              )}
              onClick={() => setDayNumber(1)}
            >
              Tomorrow
            </Button>
          </div>
          <div>
            <Button
              variant={ButtonVariant.Text}
              className={classNames(
                { 'underline underline-offset-4': dayNumber === 2 },
                'text-sm uppercase',
              )}
              onClick={() => setDayNumber(2)}
            >
              <DayOfTheWeek date={dailyForecasts[2].date} />
            </Button>
          </div>
        </div>

        {/* Daily Forecast Detail */}
        <ForecastDay forecast={dailyForecasts[dayNumber]} />
      </div>
    );
  }

  return null;
}

export default ForecastDaily;
